const KEY = "navStack";
let skipNextPush = false;

export function pushStep(fullPath) {
  if (skipNextPush) {
    skipNextPush = false;
    return;
  }

  const stack = JSON.parse(sessionStorage.getItem(KEY) || "[]");

  if (stack[stack.length - 1] === fullPath) return;

  stack.push(fullPath);

  // opcional: limitar tamaño
  if (stack.length > 50) stack.shift();

  sessionStorage.setItem(KEY, JSON.stringify(stack));
}

export function popStep() {
  const stack = JSON.parse(sessionStorage.getItem(KEY) || "[]");

  // saco la vista actual
  stack.pop();

  sessionStorage.setItem(KEY, JSON.stringify(stack));

  // marco que la próxima navegación es "back", para que NO pushee de nuevo
  skipNextPush = true;

  return stack[stack.length - 1] || "/home";
}

export function resetStack(initial = "/home") {
  sessionStorage.setItem(KEY, JSON.stringify([initial]));
}
